import api from '@/services/api';

export default {
  updateSettings({ commit }, data) {
    commit('updateSettings', data);
  },
  getTranslations({ commit }, lang) {
    api.getTranslations(lang)
      .then((response) => {
        commit('setTranslations', response.data);
      })
      .catch((err) => {
        console.warn('Error getting translations: ', err);
      });
  },
};
